export const GENERATE_PLAN = "GENERATE_PLAN";
export const GENERATE_PLAN_SUCCESS = "GENERATE_PLAN_SUCCESS";
export const GENERATE_PLAN_FAIL = "GENERATE_PLAN_FAIL";